import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotificationsContext } from '../context/NotificationsContext';
import './CityCard.css';

export default function CityCard({ city }) {
  const navigate = useNavigate();
  const { getSubscriptionsForCity } = useNotificationsContext();
  const subCount = getSubscriptionsForCity(city.slug).length;

  return (
    <button
      className="city-card"
      style={{
        '--card-primary': city.colors.primary,
        '--card-secondary': city.colors.secondary,
        '--card-accent': city.colors.accent,
      }}
      onClick={() => navigate(`/${city.slug}`)}
    >
      <div className="city-card-top">
        <div className="city-card-mark">
          {city.name.charAt(0)}
        </div>
        <div className="city-card-location">
          <div className="city-card-name">{city.name}</div>
          <div className="city-card-state">{city.state}</div>
        </div>
        {subCount > 0 && (
          <div className="city-card-sub-badge">{subCount} active</div>
        )}
      </div>

      <p className="city-card-tagline">{city.tagline}</p>

      <div className="city-card-footer">
        <div className="city-card-topics">
          {city.topics.slice(0, 4).map((t) => (
            <span key={t.id} className="city-card-topic-pill">{t.icon}</span>
          ))}
          {city.topics.length > 4 && (
            <span className="city-card-topic-pill city-card-topic-more">
              +{city.topics.length - 4}
            </span>
          )}
        </div>
        <span className="city-card-cta">Explore →</span>
      </div>

      <div className="city-card-stripe" />
    </button>
  );
}
